import React, { KeyboardEvent, useEffect, useState } from 'react';

import Select from "react-select";

import { PrimaryButton } from '@components/library/button/index';
import PrimaryInput from '@components/library/inputs/PrimaryInput';
import renderModal from '@components/show_page/modals/renderModal';

import './styles/_new_brandfolder_modal_styles.scss';

interface NewBrandfolderModalProps {
  closeModal: () => void;
  libraryName: string;
  name: string;
  slug: string;
}

const defaultTemplate = 'default';
// whenever you update these fields, make sure it matches the INITIAL_CONFIG_DEFAULTS hash
// in app/models/brandfolder.rb
const templates = [
  { value: "sales", label: t("Sales") },
  { value: "asset_library", label: t("Asset Library") },
  { value: "marketing", label: t("Marketing") },
  { value: "presskit", label: t("Press Kit") },
  { value: "archive", label: t("Archive") },
  { value: "default", label: t("Default") }
];

const NewBrandfolderModal = ({
  closeModal,
  libraryName,
  name,
  slug,
}: NewBrandfolderModalProps): JSX.Element => {
  const [newBrandfolderName, setShowNewBrandfolderName] = useState(name);
  const [selectedTemplate, setSelectedTemplate] = useState(defaultTemplate);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitComplete, setSubmitComplete] = useState(false);

  const handleSubmit = (): void => {
    const data = {
      brandfolder_name: newBrandfolderName,
      template_type: selectedTemplate
    };
    setIsSubmitting(true);
    $.ajax({
      url: `/organizations/${slug}/brandfolders/new`,
      data,
      type: "GET",
      success() {
        setIsSubmitting(false);
        setSubmitComplete(true);
        window.location.reload();
      },
      error() {
        setIsSubmitting(false);
        setSubmitComplete(false);
        Notify.create({
          title: t('Something went wrong. Try again soon!'),
          type: 'error'
        });
      },
      complete() {
        Notify.create({
          title: `${t('Brandfolder Created, reloading...')}`,
          type: "success"
        });
      }
    });
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const displayTemplateOptions = BFG.currentUser.su && !BFG.currentUser.scope;

  useEffect(() => (): void => {
    closeModal();
  }, [closeModal]);

  return (
    <div className="modal-content-wrapper">
      <div className="modal-content-wrapper__header">
        <h3>{`${t("Create New")} ${libraryName}`}</h3>
        <button
          className="close-button"
          onClick={closeModal}
          type="button"
        >
          <span className="bff-close" />
        </button>
      </div>
      <div className="modal-content-wrapper__body">
        <PrimaryInput
          attributes={{
            name: 'new-brandfolder-name-input',
            onChange: (e: InputChangeEvent): void => setShowNewBrandfolderName(e.target.value),
            onKeyPress: handleKeyPress
          }}
          input={{
            value: newBrandfolderName
          }}
        />
        {displayTemplateOptions && (
          <Select
            name="brandfolder-templates"
            value={selectedTemplate}
            options={templates}
            clearable={false}
            searchable={false}
            placeholder={t("Select Brandfolder Template")}
            onChange={(option): void => setSelectedTemplate(option.value)}
          />
        )}
        <div className="button-container">
          <PrimaryButton
            disabled={submitComplete}
            isLoading={isSubmitting}
            loadingCopy={t('Creating')}
            onClick={handleSubmit}
            size="medium"
          >
            {t('Create')}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

const ModalComponent = renderModal(NewBrandfolderModal, 'new-brandfolder-modal');
export default ModalComponent;
